import api from "./api";
class CausaService {
    static async showRestrito(id) {
        if (!id)
            return undefined;
        const url = "/restrito/causas/" + id;
        const res = await api.get(url);
        return res.data;
    }
}
export default CausaService;
